export default "__VITE_ASSET__BvJYLNDQ__"